<template>
    <div class="todo-list-page" >
        <!-- 顶部横幅 -->
        <!-- <div class="banner">
            <img src="" alt="投标保函限时活动"
                class="banner-image" />
        </div> -->
        <!-- 待办提醒区域 -->
        <div class="todo-section">
            <div class="todo-content">
                <div class="todo-header">
                    <h3 class="todo-title">待办提醒</h3>
                    <span class="todo-subtitle">(关注右侧公众号获取投标项目进度)</span>
                </div>
                <div class="todo-grid">
                    <div class="todo-card" v-for="(item, index) in todoItems" :key="index"
                        @click="handleTodoClick(item)">
                        <div class="todo-card-content">
                            <div class="todo-text">{{ item.text }}</div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- 右侧二维码区域 -->
            <div class="qr-section">
                <div class="qr-code">
                    <div class="qr-placeholder">
                        <i class="el-icon-qrcode"></i>
                    </div>
                </div>
                <p class="qr-text">扫描关注公众号</p>
                <p class="qr-desc">获取投标项目进度通知</p>
                <el-button type="text" class="qr-link" @click="showUsageDetails">点击查看使用详情</el-button>
            </div>
        </div>

        <!-- 待办详情区域 -->
        <div class="todo-details" v-if="selectedTodo">
            <div class="details-header">
                <h4>{{ selectedTodo.text }}</h4>
                <el-button type="text" @click="closeDetails">关闭</el-button>
            </div>
            <div class="details-content">
                <p>这里是 {{ selectedTodo.text }} 的详细信息...</p>
                <!-- 这里可以根据不同的待办项显示不同的内容 -->
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'TodoList',
    data() {
        return {
            selectedTodo: null,
            todoItems: [
                { text: '报名审核通知'  },
                { text: '标书款核实提醒'  },
                { text: '澄清、补遗提醒' },
                { text: '踏勘通知' },
                { text: '解答评委提问提醒' },
                { text: '确认开标记录提醒' },
                { text: '开标提醒' },
                { text: '投标截止前文件上传提醒' },
                { text: '所投项目中标公告提醒' },
                { text: '解密提醒' },       
                { text: '中标候选人公示发布提醒' },
                { text: '下载招标文件提醒' }
            ]
        }
    },
    methods: {
        handleTodoClick(item) {
            this.selectedTodo = item
            console.log('点击待办项:', item)
        },
        closeDetails() {
            this.selectedTodo = null
        },
        showUsageDetails() {
            this.$message.info('使用详情功能开发中...')
        }
    }
}
</script>

<style scoped>
.todo-list-page {
    min-height: 100%;
    padding: 0 30px;
    display: flex;
    flex-direction: column;
    background-color: #f5f5f5;
    padding-top:20px ;
}

.banner {
    width: 100%;
    margin-bottom: 20px;
}

.banner-image {
    width: 100%;
    height: auto;
    border-radius: 8px;
}

.todo-section {
    display: flex;
    text-align: start;
    padding: 20px;
    margin-bottom: 20px;
}

.todo-content {
    flex: 1;
    padding-right: 20px;
    border-right: 1px solid #ddd;
}

.todo-header {
    margin-bottom: 20px;
}

.todo-title {
    font-size: 20px;
    font-weight: bold;
    color: #333;
    margin: 0;
    display: inline-block;
}

.todo-subtitle {
    font-size: 12px;
    color: #ff4444;
    margin-left: 10px;
}

.todo-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
    gap: 15px;
}

.todo-card {
    background: white;
    border: 1px solid #ddd;
    border-radius: 8px;
    cursor: pointer;
    transition: all 0.3s ease;
    overflow: hidden;
}

.todo-card:hover {
    border-color: #409eff;
    box-shadow: 0 2px 8px rgba(64, 158, 255, 0.2);
    transform: translateY(-2px);
}

.todo-card-content {
    padding: 15px;
    display: flex;
    align-items: center;
    text-align: ce;
    min-height: 60px;
}

.todo-icon {
    font-size: 20px;
    color: #409eff;
    margin-right: 10px;
    flex-shrink: 0;
}

.todo-text {
    font-size: 14px;
    color: #333;
    line-height: 1.4;
    flex: 1;
}

.qr-section {
    width: 200px;
    text-align: center;
    margin-left: 20px;
}

.qr-code {
    background: white;
    border-radius: 8px;
    padding: 20px;
    margin-bottom: 15px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.qr-placeholder {
    width: 120px;
    height: 120px;
    background: #f5f5f5;
    border: 2px dashed #ddd;
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 auto;
}

.qr-placeholder i {
    font-size: 40px;
    color: #999;
}

.qr-text {
    font-size: 14px;
    color: #333;
    margin: 0 0 5px 0;
    font-weight: bold;
}

.qr-desc {
    font-size: 12px;
    color: #666;
    margin: 0 0 10px 0;
}

.qr-link {
    color: #409eff;
    font-size: 12px;
    padding: 0;
}

.todo-details {
    background: white;
    border-radius: 8px;
    padding: 20px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.details-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 15px;
    padding-bottom: 10px;
    border-bottom: 1px solid #eee;
}

.details-header h4 {
    margin: 0;
    color: #333;
}

.details-content {
    color: #666;
    line-height: 1.6;
}

</style>
